export default {"src":"/_next/static/media/Dermatology.eac74a09.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};